import React from 'react';
import PATHS from 'constants/paths';
import { Link } from 'react-router-dom';

import GetCustomersLogo from 'Components/GetCustomersLogo';

const { HOME } = PATHS;

const Logo = ({ isLimitedUser }) => {
  const linkTo = !isLimitedUser ? HOME : '#';
  return (
    <Link to={linkTo}>
      <GetCustomersLogo />
    </Link>
  );
};

export default Logo;
